import React from 'react';
import Bgimage from "../../images/bg-image/automation-bg-image.jpg"; 

function OurExpertise() {
  return (
    <div>
      <div className="mx-auto text-center md:py-2">
        <section
          className="w-full bg-cover bg-center bg-no-repeat text-white rounded-lg py-2 md:py-16"
          style={{ backgroundImage: `url(${Bgimage})` }} 
        >
          <div className="gap-6 items-center">
            <div className="p-2 md:p-6 rounded-lg"> 
              <h2 className="text-3xl md:text-4xl font-bold mb-2">Automotive-Metal-Steet</h2>
              <p className="sm:p-4 md:p-6 rounded-lg text-lg md:text-2xl">
                From precision-engineered components to high-performance solutions, Automotive Division delivers
                quality, durability, and efficiency for the modern automotive industry.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default OurExpertise;
